import React from 'react'
import {Container} from 'react-bootstrap'

export default function SportsBooksAccountShowPage() {
    return <Container fluid={true}>Show</Container>
}